module.exports = __webpack_public_path__ + "static/media/failed.d2c4e833.png";